<template>
    <v-container fluid class="perfil-root">
        <div class="perfil-shell">

            <v-row class="mt-1">
                <v-col cols="12">
                    <v-card class="perfil-card perfil-card--side" outlined>
                        <v-card-text class="basic-strip">
                            <div class="basic-strip__identity">
                                <v-avatar size="88" class="perfil-avatar">
                                    <v-img
                                        :src="fotoPreview || 'https://cdn-icons-png.flaticon.com/512/149/149071.png'"
                                        cover
                                    ></v-img>
                                </v-avatar>

                                <div class="basic-strip__copy">
                                    <div class="perfil-nombre">{{ nombreCompleto }}</div>
                                    <div class="perfil-subtitulo perfil-subtitulo--cargo">{{ getGradoN(perfil.oid_grado) }}</div>
                                    <div class="perfil-subtitulo perfil-subtitulo--correo">{{ perfil.correo || '-' }}</div>
                                </div>
                            </div>
                            <div class="basic-strip__content">
                                <v-row>
                                    <v-col cols="12" lg="3" md="6" xs="12">
                                        <div class="compact-pill">
                                            <span class="compact-pill__label">
                                                <v-icon x-small color="#727b4a" class="compact-pill__icon">mdi-card-account-details-outline</v-icon>
                                                Nro Escalafon
                                            </span>
                                            <span class="compact-pill__value">{{ perfil.cl1 || '-' }}</span>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" lg="3" md="6" xs="12">
                                        <div class="compact-pill">
                                            <span class="compact-pill__label">
                                                <v-icon x-small color="#727b4a" class="compact-pill__icon">mdi-card-account-details-outline</v-icon>
                                                Documento
                                            </span>
                                            <span class="compact-pill__value">{{ perfil.documento || '-' }}</span>
                                        </div>
                                    </v-col>
                                    <v-col cols="12" lg="3" md="6" xs="12">
                                        <div class="compact-pill">
                                            <span class="compact-pill__label">
                                                <v-icon x-small color="#727b4a" class="compact-pill__icon">mdi-phone-outline</v-icon>
                                                Teléfono
                                            </span>
                                            <span class="compact-pill__value">{{ perfil.telefono || '-' }}</span>
                                        </div>  
                                    </v-col>
                                    <v-col cols="12" lg="3" md="6" xs="12">
                                        <div class="compact-pill">
                                            <span class="compact-pill__label">
                                                <v-icon x-small color="#727b4a" class="compact-pill__icon">mdi-map-marker-outline</v-icon>
                                                Dirección
                                            </span>
                                            <span class="compact-pill__value">{{ perfil.direccion || '-' }}</span>
                                        </div>  
                                    </v-col>
                                </v-row>
                            </div>
                        </v-card-text>
                    </v-card>
                </v-col>

                <v-col cols="12">
                    <v-card class="perfil-card mt-2" outlined>
                        <v-card-text class="pa-4">
                    <div class="section-title section-title--dialog mb-4" style="justify-content: center;">
                        <v-icon left color="#f7c325">mdi-account</v-icon>
                        DATOS PERSONALES
                    </div>

                    <v-row>
                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Nombres</div>
                                <div class="info-value">{{ perfil.nombres || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Apellido paterno</div>
                                <div class="info-value">{{ perfil.primero_apellido || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Apellido materno</div>
                                <div class="info-value">{{ perfil.segundo_apellido || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Tercer apellido</div>
                                <div class="info-value">{{ perfil.tercer_apellido || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Correo</div>
                                <div class="info-value">{{ perfil.correo || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Tipo Documento</div>
                                <div class="info-value">{{ (catMap.TipoDocumento || {})[perfil.oid_tipo_documento] || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Documento</div>
                                <div class="info-value">{{ perfil.documento || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Expedido</div>
                                <div class="info-value">{{ perfil.expedido || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Género</div>
                                <div class="info-value">{{ (catMap.Genero || {})[perfil.oid_genero] || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Fecha Nacimiento</div>
                                <div class="info-value">
                                    {{ formatoFecha(perfil.fecha_nacimiento) }}
                                </div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Edad</div>
                                <div class="info-value">
                                    {{ calcularEdad(perfil.fecha_nacimiento) || '—' }}
                                </div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Estado Civil</div>
                                <div class="info-value">{{ (catMap.EstadoCivil || {})[perfil.oid_estado_civil] || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Teléfono</div>
                                <div class="info-value">{{ perfil.telefono || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Nacionalidad origen</div>
                                <div class="info-value">{{ (catMap.Nacionalidad || {})[perfil.oid_nacionalidad_origen] || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Nacionalidad actual</div>
                                <div class="info-value">{{ (catMap.Nacionalidad || {})[perfil.oid_nacionalidad_actual] || '—' }}</div>
                            </div>
                        </v-col>
                    </v-row>

                    <div class="section-title section-title--dialog mt-6 mb-4" style="justify-content: center;">
                        <v-icon left color="#f7c325">mdi-map-marker-radius</v-icon>
                        LUGAR DE NACIMIENTO
                    </div>

                    <v-row>
                        <v-col cols="12" md="4">
                            <div class="info-box">
                                <div class="info-label">País nacimiento</div>
                                <div class="info-value">{{ getPaisN(perfil.oid_pais_nacimiento) }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="4">
                            <div class="info-box">
                                <div class="info-label">Departamento nacimiento</div>
                                <div class="info-value">{{ getDeptoN(perfil.oid_depto_nacimiento) }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="4">
                            <div class="info-box">
                                <div class="info-label">Ciudad nacimiento</div>
                                <div class="info-value">{{ getCiudadN(perfil.oid_ciudad_nacimiento) }}</div>
                            </div>
                        </v-col>
                    </v-row>

                    <div class="section-title section-title--dialog mt-6 mb-4" style="justify-content: center;">
                        <v-icon left color="#f7c325">mdi-home-city</v-icon>
                        DOMICILIO ACTUAL
                    </div>

                    <v-row>
                        <v-col cols="12" md="4">
                            <div class="info-box">
                                <div class="info-label">Dirección</div>
                                <div class="info-value">{{ perfil.direccion || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="2">
                            <div class="info-box">
                                <div class="info-label">Calle</div>
                                <div class="info-value">{{ perfil.calle || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Zona</div>
                                <div class="info-value">{{ perfil.zona || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Nro domicilio</div>
                                <div class="info-value">{{ perfil.nro_domicilio || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="4">
                            <div class="info-box mb-0">
                                <div class="info-label">País</div>
                                <div class="info-value">{{ getPaisN(perfil.oid_pais) }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="4">
                            <div class="info-box mb-0">
                                <div class="info-label">Departamento</div>
                                <div class="info-value">{{ getDeptoN(perfil.oid_depto) }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="4">
                            <div class="info-box mb-0">
                                <div class="info-label">Ciudad</div>
                                <div class="info-value">{{ getCiudadN(perfil.oid_ciudad) }}</div>
                            </div>
                        </v-col>
                    </v-row>

                    <div class="section-title section-title--dialog mt-6 mb-4" style="justify-content: center;">
                        <v-icon left color="#f7c325">mdi-shield-account</v-icon>
                        INFORMACIÓN ADICIONAL
                    </div>

                    <v-row>
                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Código de salud</div>
                                <div class="info-value">{{ perfil.cod_salud || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Registro CUA</div>
                                <div class="info-value">{{ perfil.registro_cua || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Nro. cuenta</div>
                                <div class="info-value">{{ perfil.nro_cuenta || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Grado incapacidad</div>
                                <div class="info-value">{{ perfil.grado_incapacidad || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Bono egresado</div>
                                <div class="info-value">{{ perfil.bono_egresado || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="3">
                            <div class="info-box">
                                <div class="info-label">Código cargo</div>
                                <div class="info-value">{{ perfil.cod_cargo || '—' }}</div>
                            </div>
                        </v-col>
                    </v-row>

                    <div class="section-title section-title--dialog mt-6 mb-4" style="justify-content: center;">
                        <v-icon left color="#f7c325">mdi-phone-alert</v-icon>
                        CONTACTO DE EMERGENCIA
                    </div>

                    <v-row>
                        <v-col cols="12" md="4">
                            <div class="info-box mb-0">
                                <div class="info-label">Nombre contacto</div>
                                <div class="info-value">{{ perfil.n_contacto || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="4">
                            <div class="info-box mb-0">
                                <div class="info-label">Nro contacto</div>
                                <div class="info-value">{{ perfil.nro_contacto || '—' }}</div>
                            </div>
                        </v-col>

                        <v-col cols="12" md="4">
                            <div class="info-box mb-0">
                                <div class="info-label">Fecha registro</div>
                                <div class="info-value">{{ formatoFecha(perfil.created_at) }}</div>
                            </div>
                        </v-col>
                    </v-row>
                </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
            <v-row>
                <v-col cols="12">
                    <v-card class="perfil-card" outlined>
                        <v-card-text>
                            <v-tabs v-model="activeTab" background-color="transparent" color="#5e672c" grow >
                                <v-tab href="#tab-1">
                                    <v-icon left small>mdi-briefcase-clock</v-icon> Histórico Laboral
                                </v-tab>
                                <v-tab href="#tab-2">
                                    <v-icon left small>mdi-timeline-clock-outline</v-icon> Histórico Estados
                                </v-tab>
                                <v-tab href="#tab-3">
                                    <v-icon left small>mdi-file-document-outline</v-icon> Memorandos
                                </v-tab>
                                <v-tab href="#tab-4">
                                    <v-icon left small>mdi-medal-outline</v-icon> Méritos
                                </v-tab>
                                <v-tab href="#tab-5">
                                    <v-icon left small>mdi-gavel</v-icon> Denuncias
                                </v-tab>
                                <v-tab href="#tab-6">
                                    <v-icon left small>mdi-heart-pulse</v-icon> Salud
                                </v-tab>
                            </v-tabs>
                            <v-tabs-items v-model="activeTab">
                                <!-- TAB 1: -->
                                <v-tab-item value="tab-1">
                                    <div class="mt-4">
                                        <h2>Histórico Laboral</h2>
                                        <v-divider class="mx-4" inset vertical></v-divider> 
                                        <v-simple-table class="historial-table">
                                            <template v-slot:default>
                                                <thead>
                                                    <tr>
                                                        <th>#</th>
                                                        <th>Grado</th>
                                                        <th>Cargo</th>
                                                        <th>Unidad</th>
                                                        <th>Destino</th>
                                                        <th>Fecha inicio</th>
                                                        <th>Fecha fin</th>
                                                        <th>Acción</th>
                                                        <th>Observación</th>
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr v-for="(item, index) in historialLaboral" :key="item.oid || index">
                                                        <td>{{ index + 1 }}</td>
                                                        <td>{{ getGradoN(item.oid_grado) }}</td>
                                                        <td>{{ getCargoN(item.oid_cargo) }}</td>
                                                        <td>{{ getUnidadN(item.oid_unidad) }}</td>
                                                        <td>{{ getDestinoN(item.oid_destino) }}</td>
                                                        <td>{{ formatoFecha(item.fecha_inicio) }}</td>
                                                        <td>{{ formatoFecha(item.fecha_fin) }}</td>
                                                        <td>{{ getAccionHistorial(item.accion) }}</td>
                                                        <td>{{ item.observacion || '—' }}</td>
                                                    </tr>

                                                    <tr v-if="!historialLaboral || historialLaboral.length === 0">
                                                        <td colspan="9" class="text-center historial-empty">
                                                            No hay histórico laboral registrado.
                                                        </td>
                                                    </tr>
                                                </tbody>
                                            </template>
                                        </v-simple-table>
                                    </div>
                                </v-tab-item>
                                <!-- TAB 2: -->
                                <v-tab-item value="tab-2">
                                    <div class="mt-4">
                                        <h2>Histórico Estados</h2>
                                        <v-divider class="mx-4" inset vertical></v-divider> 
                                    <v-simple-table class="historial-table">
                                        <template v-slot:default>
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Estado</th>
                                                    <th>Fecha inicio</th>
                                                    <th>Fecha fin</th>
                                                    <th>Observación</th>
                                                </tr>
                                            </thead>

                                            <tbody>
                                                <tr v-for="(item, index) in historialEstados" :key="item.oid || index">
                                                    <td>{{ index + 1 }}</td>
                                                    <td>{{ getEstadoN(item.oid_estado) }}</td>
                                                    <td>{{ formatoFecha(item.fecha_inicio) }}</td>
                                                    <td>{{ formatoFecha(item.fecha_fin) }}</td>
                                                    <td>{{ item.observacion || '—' }}</td>
                                                </tr>

                                                <tr v-if="!historialEstados || historialEstados.length === 0">
                                                    <td colspan="6" class="text-center historial-empty">
                                                        No hay histórico de estados registrado.
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </template>
                                    </v-simple-table>
                                    </div>
                                </v-tab-item>
                                <!-- TAB 3: -->
                                <v-tab-item value="tab-3">
                                    <div class="mt-4">
                                        <h2>Memorandos</h2>
                                        <v-divider class="mx-4" inset vertical></v-divider> 
                                    </div>
                                </v-tab-item>
                                <!-- TAB 4: -->
                                <v-tab-item value="tab-4">
                                    <div class="mt-4">
                                        <h2>Meritos</h2>
                                        <v-divider class="mx-4" inset vertical></v-divider> 
                                    </div>
                                </v-tab-item>
                                <!-- TAB 5: -->
                                <v-tab-item value="tab-5">
                                    <div class="mt-4">
                                        <h2>Denuncias</h2>
                                        <v-divider class="mx-4" inset vertical></v-divider> 
                                    </div>
                                </v-tab-item>
                                <!-- TAB 6: -->
                                <v-tab-item value="tab-6">
                                    <div class="mt-4">
                                        <h2>Salud</h2>
                                        <v-divider class="mx-4" inset vertical></v-divider> 
                                    </div>
                                </v-tab-item>
                            </v-tabs-items>
                        </v-card-text>
                    </v-card>
                </v-col>
            </v-row>
        </div>

        <v-snackbar v-model="snackbar" :color="snackbarColor" timeout="5000" top>
            {{ snackbarMensaje }}
            <template v-slot:action="{ attrs }">
                <v-btn text v-bind="attrs" @click="snackbar = false">Cerrar</v-btn>
            </template>
        </v-snackbar>
        
    </v-container>
</template>
  
<script>
import axios from 'axios';
import { setEstados, getEstadoN } from '@/utils/validators';
import {
  loadAll, getOptionsByCodigo,
  setDatos, getPaises, getDeptos, getCiudades,
  getPaisN, getDeptoN, getCiudadN,
  getNameById
} from '@/utils/catalogo';

export default {
    name: 'DetalleFuncionario',
    components: {
        
    },
    props: {
        componente: Array,
        personaId: { type: Number, required: false, default: null },
        soloLectura: { type: Boolean, default: false },
    },
    data() {
        return {
            datos: [], Ldomicilios: [],Lestado: [],
            LPais: [], LDepto: [], LCiudad: [], Lgrado: [], Lcargo: [], Lunidad: [], Ldestino: [],
            dato: {
                oid: 0,
                correo: '',
                nombres: '',
                primero_apellido: "",
                segundo_apellido: "",
                oid_tipo_documento: null,
                documento: '',
                oid_genero: null,
                fecha_nacimiento: null,
                oid_pais_nacimiento: null,
                oid_nacionalidad_origen: null,
                oid_nacionalidad_actual: null,
                oid_estado_civil: null,
                direccion: '',
                oid_pais: null,
                oid_depto: null,
                oid_ciudad: null,
                telefono: '',
                oid_estado: null,
                cl1: '',
                cl2: '',
                fecha_ingreso: null,
                fecha_retiro: null,
                fecha_reintegro: null,
                oid_grado: null,
                oid_cargo: null,
                oid_unidad: null,
                oid_destino: null,
            },
            isNew: true,
            Ops: [
                { oid: 1, nombre: 'Si' },
                { oid: 0, nombre: 'No' },
            ],
            dialog: false, // Controla la visibilidad del diálogo
            formTitle: '', // Título del diálogo
            dialogdetail: false, 
            dialog_familiar: false,
            showConfirmDialog: false,
            confirmItemId: null,
            search: '', // Valor del campo de búsqueda
            dialog_guardando: false,
            snackbar: false,
            snackbarMensaje: '',
            snackbarColor: 'error',
            rules: {
                required: v => v !== null && v !== undefined && v !== '' || 'Requerido',
                maxValue: max => v =>
                    (!v || Number(v) <= max) || `El valor no puede ser mayor a ${max}`,
                select: v => (v !== null && v !== undefined && v !== '') || 'Selecciona una opción',
            },
            formValid: false,
            fotoPreview: "",
            perfil: {
                oid: 0,
                correo: "",
                activo: false,
                nombres: "",
                primero_apellido: "",
                segundo_apellido: "",
                documento: "",
                telefono: "",
                fecha_nacimiento: null,
                direccion: "",
                verificado: null,
                created_at: null
            },
            Catalogo: {
                EstadoCivil: [],
                TipoDocumento: [],
                Nacionalidad: [],
                Genero: [],
            },
            activeTab: 'tab-1',
            historialLaboral: [],
            historialEstados: [],
            loadingTable: false,
        };
    },
    computed: {
        headers() {
            const baseHeaders = [
                { text: 'Acciones', value: 'actions', sortable: false },
                { text: 'Nombres', value: 'names' },
                { text: 'Apellidos', value: 'surname' },
                { text: 'Email', value: 'email' },
                { text: 'Rol', value: 'rol' },
                { text: 'Área', value: 'area' },
                { text: 'Activo', value: 'activo' },
            ];

            return baseHeaders;
        },
        userName() {
            const user = localStorage.getItem('userName'); 
            return user;
        },
        rolOid() {
            const oid_rol = localStorage.getItem('rolu');
            return Number(oid_rol);
        },    
        userOid() {
            const oid_user = localStorage.getItem('oidu');
            return Number(oid_user);
        },  
        personaOid() {
            const oid_persona = localStorage.getItem('oidpersonau');
            return Number(oid_persona);
        },
        nombreCompleto() {
            return [
                this.perfil.nombres,
                this.perfil.primero_apellido,
                this.perfil.segundo_apellido
            ]
            .filter(Boolean)
            .join(" ");
        },
        catMap() {
            const toMap = arr => (arr || []).reduce((m, it) => { m[it.oid] = it.nombre; return m; }, {});
            return {
                TipoDocumento: toMap(this.Catalogo.TipoDocumento),
                Nacionalidad:  toMap(this.Catalogo.Nacionalidad),
                Genero:        toMap(this.Catalogo.Genero),
                EstadoCivil:   toMap(this.Catalogo.EstadoCivil),
            };
        }
    },
    watch: {
        personaId: {
            handler(newVal) {
                this.perfil.oid = newVal;
                this.cargarPerfil();
            },
            immediate: true,
        }
    },
    async mounted() {
        await this.cargarCatalogos();
        await this.cargarCatalogosLaborales();
        
        this.Lestado = await setEstados();

        await setDatos();
        this.LPais   = getPaises();
        this.LDepto  = getDeptos();
        this.LCiudad = getCiudades();
        
        this.listar();
    },
    methods: {
        getEstadoN,getPaisN, getDeptoN, getCiudadN, getNameById,
        // Obtener la lista
        async listar() {
            try {
                this.loadingTable = true;

                let idUsuario = null;

                if (this.personaId !== null && this.personaId !== undefined) {
                    idUsuario = Number(this.personaId);
                } else {
                    idUsuario = Number(this.personaOid);
                }

                if (!idUsuario || isNaN(idUsuario)) {
                    this.snackbarMensaje = "No se encontró el usuario en sesión";
                    this.snackbarColor = "error";
                    this.snackbar = true;
                    return;
                }

                const [historialResponse, estadosResponse] = await Promise.all([
                    axios.get(`api/PersonaHistorials/MostrarPorPersona/${idUsuario}`),
                    axios.get(`api/PersonaHistorialEstados/MostrarPorPersona/${idUsuario}`)
                ]);
                
                this.historialLaboral = historialResponse.data || [];
                this.historialEstados = estadosResponse.data || [];

            } catch (error) {
                console.error(error);
                this.snackbarMensaje = "Error al listar funcionarios";
                this.snackbarColor = "error";
                this.snackbar = true;
            } finally {
                this.loadingTable = false;
            }
        },
        async cargarCatalogosLaborales() {
            try {
                const [responseG, responseC, responseU, responseD] = await Promise.all([
                    axios.get('api/Grados/Listar'),
                    axios.get('api/Cargos/Listar'),
                    axios.get('api/Unidads/Listar'),
                    axios.get('api/Destinos/Listar')
                ]);

                this.Lgrado = responseG.data;
                this.Lcargo = responseC.data;
                this.Lunidad = responseU.data;
                this.Ldestino = responseD.data;
            } catch (error) {
                console.error(error);
            }
        },
        async cargarCatalogos() {
            await loadAll();

            this.Catalogo.TipoDocumento   = getOptionsByCodigo('TipoDocumento');
            this.Catalogo.Nacionalidad = getOptionsByCodigo('Nacionalidad');
            this.Catalogo.Genero        = getOptionsByCodigo('Genero');
            this.Catalogo.EstadoCivil        = getOptionsByCodigo('EstadoCivil');
        },
        formatoFecha(fecha) {
            if (!fecha) return "-";
            const f = new Date(fecha);
            if (isNaN(f)) return fecha;
            return f.toLocaleDateString("es-BO", {
                year: "numeric",
                month: "long",
                day: "numeric"
            });
        },
        async cargarPerfil() {
            try {
                let idUsuario = null;

                // Si viene desde otro componente, usar ese id
                if (this.personaId !== null && this.personaId !== undefined) {
                    idUsuario = Number(this.personaId);
                } else {
                    // Si no viene prop, usar el usuario en sesión
                    idUsuario = Number(this.personaOid);
                }

                if (!idUsuario || isNaN(idUsuario)) {
                    this.snackbarMensaje = "No se encontró el usuario en sesión";
                    this.snackbarColor = "error";
                    this.snackbar = true;
                    return;
                }

                const response = await axios.get(`api/PersonaInfoGenerals/Mostrar/${idUsuario}`);
                this.perfil = response.data || {};
            } catch (error) {
                console.error("Error al cargar el perfil:", error);
                this.snackbarMensaje = "Error al cargar la información del perfil";
                this.snackbarColor = "error";
                this.snackbar = true;
            }
        },
        getGradoN(id) {
            const item = (this.Lgrado || []).find(x => Number(x.oid) === Number(id));
            return item ? item.nombre : '—';
        },
        getCargoN(id) {
            const item = (this.Lcargo || []).find(x => Number(x.oid) === Number(id));
            return item ? item.nombre : '—';
        },
        getUnidadN(id) {
            const item = (this.Lunidad || []).find(x => Number(x.oid) === Number(id));
            return item ? item.nombre : '—';
        },
        getDestinoN(id) {
            const item = (this.Ldestino || []).find(x => Number(x.oid) === Number(id));
            return item ? item.nombre : '—';
        },
        // Mostrar detalles
        async mostrar(id) {
            try {
                const response = await axios.get(`api/PersonaInfoGenerals/Mostrar/${id}`);
                this.dato = response.data;
                this.isNew = false;
                this.formTitle = 'Detalle Usuario';
                this.dialogdetail = true;
            } catch (error) {
                console.error(error);
            }
        },
        // Abrir el diálogo para crear una nuevo
        nueva() {
            this.dato = {
                oid: 0,
                names: '',
                surname: '',
                email: '',
                oid_rol: null,
                oid_area: null,
                activo: null
            };
            this.isNew = true;
            this.formTitle = 'Crear Usuario';
            this.dialog = true;
            this.$nextTick(() => {
                this.$refs.form && this.$refs.form.resetValidation();
                this.formValid= false;
            });
        },
        // Abrir el diálogo para actualizar
        editar(dato) {
            this.dato = { ...dato };
            this.isNew = false;
            this.formTitle = 'Actualizar Usuario';
            this.dialog = true;
        },
        // Guardar creada o actualizada
        async guardar() {
            // VALIDACION
            const ok = this.$refs.form && this.$refs.form.validate();
            if (!ok) return;

            this.dialog_guardando = true;
            try {        
                if (this.isNew) {
                    // Crear el área
                    const respuestaCrear = await axios.post('api/PersonaInfoGenerals/Crear', this.dato);
                } else {
                    // Actualizar el área
                    await axios.put(`api/PersonaInfoGenerals/Actualizar`, this.dato);
                }

                // Reset del formulario
                if (this.$refs.form) {
                    this.$refs.form.reset();
                    this.$refs.form.resetValidation();
                }

                // Limpiar el formulario después de guardar o actualizar
                this.dato = { 
                    oid: 0, 
                    names: '',
                    surname: '',
                    email: '',
                    oid_rol: null,
                    oid_area: null,
                    activo: null
                };
                // Después de guardar exitosamente el registro:
                this.dialog = false;
                await this.listar();
                
                this.snackbarMensaje = "Se guardo correctamente";
                this.snackbarColor = "success";
                this.snackbar = true;
            }catch(error) {
                console.error(error);
                this.snackbarMensaje = "Error al guardar";
                this.snackbarColor = "error";
                this.snackbar = true;
            } finally {
                // Independientemente de si la solicitud tuvo éxito o no, detenemos el estado de carga.
                this.dialog_guardando = false;
            }
        },
        // Eliminar
        async eliminar(id) {
            try {
                await axios.delete(`api/PersonaInfoGenerals/Eliminar/${id}`);
                this.listar();
                this.cancelarEliminar();
            } catch (error) {
                console.error(error);
            }
        },
        // Confirmar eliminación
        confirmarEliminar(id) {
            this.confirmItemId = id;
            this.showConfirmDialog = true;
        },
        // Cancelar eliminación
        cancelarEliminar() {
            this.confirmItemId = null;
            this.showConfirmDialog = false;
        },
        getAccionHistorial(accion) {
            const acciones = {
                1: 'Corrección',
                2: 'Actualización'
            };

            return acciones[Number(accion)] || '—';
        },
        calcularEdad(fechaNacimiento) {
            if (!fechaNacimiento) return null;

            const nacimiento = new Date(fechaNacimiento);

            if (isNaN(nacimiento)) return null;

            const hoy = new Date();

            let edad = hoy.getFullYear() - nacimiento.getFullYear();

            const mes = hoy.getMonth() - nacimiento.getMonth();

            if (
                mes < 0 ||
                (mes === 0 && hoy.getDate() < nacimiento.getDate())
            ) {
                edad--;
            }

            return `${edad} años`;
        },
    },
};
</script> 

<style scoped>
p {
    font-family: 'Heebo', sans-serif !important;
}

h1 {
    font-family: 'Heebo', sans-serif !important;
}

.perfil-root {
    background:
        radial-gradient(circle at top right, rgba(201, 165, 56, 0.12), transparent 26%),
        linear-gradient(180deg, #f7f8f3 0%, #eef0ea 100%);
    padding: 20px;
    padding-bottom: 48px;
    box-sizing: border-box;
    min-height: calc(100vh - 80px);
}

.perfil-shell {
    width: min(calc(100% - 24px), 1360px);
    max-width: 1360px;
    margin: 0 auto;
}

.perfil-title {
    color: #ffffff;
    font-size: 24px;
    font-weight: 800;
    margin: 0;
    letter-spacing: 0.04em;
    line-height: 1.1;
}

.status-pill {
    min-width: 120px;
    padding: 8px 14px;
    border-radius: 14px;
    background: rgba(255, 255, 255, 0.16);
    border: 1px solid rgba(255, 255, 255, 0.18);
}

.status-pill--soft {
    background: rgba(255, 255, 255, 0.1);
}

.status-pill__label {
    display: block;
    color: #e4b510;
    font-size: 11px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.08em;
}

.status-pill__value {
    display: block;
    color: #ffffff;
    font-size: 18px;
    font-weight: 800;
    margin-top: 3px;
}

.perfil-card {
    background: #ffffff !important;
    border: 1px solid rgba(108, 117, 51, 0.14) !important;
    border-radius: 20px !important;
    box-shadow: 0 14px 36px rgba(59, 71, 33, 0.08);
}

.perfil-card--side {
    background: linear-gradient(180deg, #ffffff 0%, #f4f5f0 100%) !important;
}

.basic-strip {
    display: grid;
    grid-template-columns: minmax(320px, 520px) minmax(0, 1fr);
    gap: 20px;
    align-items: center;
    padding: 18px 20px !important;
}

.basic-strip__identity {
    display: flex;
    align-items: center;
    gap: 18px;
    padding-right: 10px;
    border-right: 1px solid rgba(108, 117, 51, 0.14);
}

.basic-strip__copy {
    min-width: 0;
}

.basic-strip__content {
    min-width: 0;
    width: 100%;
    display: flex;
    justify-content: flex-end;
}

.perfil-avatar {
    border: 4px solid #f7c325;
    box-shadow: 0 0 0 8px rgba(231, 181, 16, 0.12);
}

.perfil-nombre {
    color: #384018;
    font-size: 24px;
    font-weight: 800;
    text-transform: uppercase;
    line-height: 1.2;
}

.perfil-subtitulo {
    color: #6b7280;
    font-size: 13px;
    font-weight: 700;
    letter-spacing: 0.08em;
}

.perfil-subtitulo--cargo {
    margin-top: 6px;
    margin-bottom: 1px;
}

.perfil-subtitulo--correo {
    margin-top: 0;
    letter-spacing: 0.03em;
    text-transform: none;
}

.section-title {
    color: #5e672c;
    font-size: 21px;
    font-weight: 800;
    text-transform: uppercase;
    display: flex;
    align-items: center;
    border-bottom: 1px solid rgba(108, 117, 51, 0.18);
    padding-bottom: 10px;
    letter-spacing: 0.02em;
}

.section-title--dialog {
    color: #384018;
    font-size: 18px;
}

.section-title--compact {
    font-size: 17px;
    padding-bottom: 8px;
}

.info-box {
    background: linear-gradient(180deg, #f8f9f6 0%, #eef0eb 100%);
    border: 1px solid rgba(108, 117, 51, 0.12);
    border-left: 4px solid #c9a538;
    border-radius: 14px;
    padding: 6px 10px;
    margin-bottom: 12px;
    min-height: 50px;
}

.info-box--compact {
    min-height: 50px;
    padding: 6px 10px;
    margin-bottom: 8px;
}

.info-label {
    color: #727b4a;
    font-size: 12px;
    font-weight: 800;
    margin-bottom: 1px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
}

.info-value {
    color: #303641;
    font-size: 16px;
    font-weight: 700;
    line-height: 1.35;
    word-break: break-word;
}

.compact-summary-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 10px;
}

.compact-summary-grid--wide {
    width: min(100%, 920px);
    grid-template-columns: minmax(140px, 160px) minmax(140px, 160px) minmax(140px, 160px) minmax(140px, 160px);
    justify-content: end;
}

.compact-pill {
    background: rgba(255, 255, 255, 0.78);
    border: 1px solid rgba(108, 117, 51, 0.12);
    border-radius: 14px;
    padding: 11px 12px;
    min-height: 74px;
}

.compact-pill--full {
    grid-column: span 2;
}

.compact-pill__label {
    display: flex;
    align-items: center;
    gap: 6px;
    color: #727b4a;
    font-size: 11px;
    font-weight: 800;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    margin-bottom: 6px;
}

.compact-pill__icon {
    flex: 0 0 auto;
}

.compact-pill__value {
    display: block;
    color: #303641;
    font-size: 14px;
    font-weight: 700;
    line-height: 1.35;
    word-break: break-word;
}

.menu-grid {
    display: grid;
    grid-template-columns: repeat(6, minmax(0, 1fr));
    column-gap: 50px;
    row-gap: 14px;
}

.menu-grid--four-up {
    grid-template-columns: repeat(4, minmax(0, 1fr));
}

.menu-grid__item {
    min-width: 0;
}

.menu-card {
    background: linear-gradient(180deg, #f9faf8 0%, #f1f3ed 100%) !important;
    border: 1px solid rgba(108, 117, 51, 0.14);
    border-radius: 18px !important;
    min-height: 128px;
    padding: 18px 12px;
    text-align: center;
    cursor: pointer;
    transition: transform 0.22s ease, box-shadow 0.22s ease, border-color 0.22s ease;
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.menu-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 14px 24px rgba(59, 71, 33, 0.12);
    border-color: rgba(201, 165, 56, 0.65);
}

.menu-icon-wrapper {
    margin-bottom: 6px;
}

.menu-title {
    color: #384018;
    font-size: 16px;
    font-weight: 800;
    margin-bottom: 2px;
    line-height: 1.2;
}

.menu-subtitle {
    color: #6b7280;
    font-size: 12px;
    line-height: 1.2;
}

.dialog-card {
    background: #fbfcfa !important;
}

.dialog-header {
    background: linear-gradient(180deg, #eef0ea 0%, #e2e6d8 100%);
    border-bottom: 1px solid rgba(108, 117, 51, 0.15);
}

.dialog-title {
    font-size: 22px;
}

.header-close {
    background: rgba(255, 255, 255, 0.9);
    border: 1px solid rgba(108, 117, 51, 0.14);
}

.dialog-action {
    background: #5e672c !important;
    color: #ffffff !important;
    border-radius: 12px !important;
    padding: 0 18px !important;
}

.legend-label {
    color: #4b5563;
    font-size: 14px;
    font-weight: 700;
}

.mapa-surface {
    height: 300px;
    border-radius: 16px;
    border: 1px solid rgba(108, 117, 51, 0.14);
    overflow: hidden;
    box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.35);
}

.v-dialog {
    border-radius: 18px !important;
}

.marker-red {
    filter: hue-rotate(0deg) saturate(2.5) brightness(1);
}

.marker-blue {
    filter: hue-rotate(180deg) saturate(2.5) brightness(1);
}

.legend-dot {
    width: 14px;
    height: 14px;
    border-radius: 50%;
    display: inline-block;
    border: 2px solid #ffffff;
}

.legend-dot-red {
    background: #d32f2f;
}

.legend-dot-blue {
    background: #1976d2;
}

.historial-table {
    background: #ffffff !important;
    border-radius: 16px;
    overflow: hidden;
    border: 1px solid rgba(108, 117, 51, 0.14);
}

.historial-table table {
    width: 100%;
    border-collapse: collapse;
}

.historial-table thead {
    background: rgba(201, 165, 56, 0.14);
}

.historial-table th {
    color: #5e672c !important;
    font-weight: 800;
    font-size: 13px;
    text-transform: uppercase;
    padding: 12px 10px !important;
    border-bottom: 1px solid rgba(108, 117, 51, 0.12);
}

.historial-table td {
    color: #303641 !important;
    padding: 11px 10px !important;
    border-bottom: 1px solid rgba(108, 117, 51, 0.08);
}

.historial-table tbody tr:hover {
    background: rgba(108, 117, 51, 0.04);
}

.historial-empty {
    color: #6b7280 !important;
    font-weight: 700;
}

@media (min-width: 1600px) {
    .perfil-shell {
        width: min(calc(100% - 32px), 1680px);
        max-width: 1680px;
    }
}

@media (max-width: 1264px) {
    .perfil-title {
        font-size: 22px;
    }

    .menu-card {
        min-height: 96px;
    }

    .compact-summary-grid--wide {
        grid-template-columns: minmax(130px, 0.85fr) minmax(130px, 0.85fr) minmax(200px, 1.3fr);
    }
}

@media (max-width: 960px) {
    .perfil-root {
        padding: 14px;
        padding-bottom: 36px;
    }

    .perfil-title {
        font-size: 22px;
    }

    .perfil-nombre {
        font-size: 21px;
    }

    .section-title {
        font-size: 18px;
    }

    .menu-title {
        font-size: 16px;
    }

    .menu-grid--four-up {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .compact-summary-grid {
        grid-template-columns: repeat(2, minmax(0, 1fr));
    }

    .basic-strip {
        grid-template-columns: 1fr;
        gap: 14px;
    }

    .basic-strip__identity {
        border-right: 0;
        padding-right: 0;
        padding-bottom: 12px;
        border-bottom: 1px solid rgba(108, 117, 51, 0.14);
    }

    .basic-strip__content {
        justify-content: stretch;
    }

    .compact-summary-grid--wide {
        grid-template-columns: repeat(2, minmax(0, 1fr));
        width: 100%;
    }
}

@media (max-width: 600px) {

    .status-pill {
        min-width: 0;
        width: calc(50% - 6px);
    }

    .menu-grid {
        grid-template-columns: 1fr;
    }

    .compact-summary-grid {
        grid-template-columns: 1fr;
    }

    .compact-summary-grid--wide {
        grid-template-columns: 1fr;
    }

    .compact-pill--full {
        grid-column: auto;
    }
}
</style>
